import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Stack,
    Switch,
    TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { isJsonArrayText } from './jsonRules';

type RulesToggleFieldProps = {
    label: string;
    checked: boolean;
    onToggle: (checked: boolean) => void;
    value: string;
    onChange: (value: string) => void;
    helpButton?: React.ReactNode;
};

export const RulesToggleField = ({ label, checked, onToggle, value, onChange, helpButton }: RulesToggleFieldProps) => {
    const [open, setOpen] = useState(false);
    const [draft, setDraft] = useState(value);

    const openDialog = () => {
        setDraft(value);
        setOpen(true);
    };
    const valid = isJsonArrayText(draft);
    const save = () => {
        onChange(draft);
        setOpen(false);
    };

    return (
        <Stack direction="row" alignItems="center">
            <FormControlLabel
                // FormControlLabel defaults to margin-left: -11px. MUI's Stack only generates
                // its own margin-reset rule when `spacing` is truthy (see createStack.js —
                // `if (ownerState.spacing)`), and this Stack has no spacing prop (falsy 0), so
                // it never resets FormControlLabel's margin on its own. Zero it explicitly so
                // this switch's track starts flush with every other row's.
                sx={{ ml: 0 }}
                control={<Switch checked={checked} onChange={e => onToggle(e.target.checked)} />}
                label={label}
            />
            <IconButton aria-label={`Edit ${label} rules`} onClick={openDialog} size="small">
                <EditIcon fontSize="small" />
            </IconButton>
            {helpButton}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>{`${label} — rules`}</DialogTitle>
                <DialogContent>
                    <TextField
                        multiline
                        minRows={10}
                        fullWidth
                        value={draft}
                        onChange={e => setDraft(e.target.value)}
                        error={!valid}
                        helperText={valid ? ' ' : 'Rules must be a valid JSON array.'}
                        inputProps={{ style: { fontFamily: 'monospace' } }}
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={save} disabled={!valid} variant="contained">Save</Button>
                </DialogActions>
            </Dialog>
        </Stack>
    );
};
